import { Component } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';
import { KycUpdateData } from '../../_models/data.structures';
import { CustomerService } from '../../_services/customer.service';

export interface KycRevokeDialogModel {
    title: string;
    kycUpdateData: KycUpdateData;
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
}

@Component({
    templateUrl: 'kyc.revoke.dialog.component.html'
})

export class KycRevokeDialogComponent extends DialogComponent<KycRevokeDialogModel, string> implements KycRevokeDialogModel {
    title: string;
    kycUpdateData: KycUpdateData;
    customerService: CustomerService;
    subValue: string;
    opcoValue: string;

    constructor(private ds: DialogService) {
          super(ds);
    }

    RevokeKYCStatus() {  
        this.customerService.RevokeKYCStatus(this.subValue, this.opcoValue, this.kycUpdateData, this.ds);
        this.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/details/kyc/kyc.revoke.dialog.component.ts